module.exports = __webpack_public_path__ + "carticon-empty.06c345b4.svg";